<template>
  <vx-card>
    <div id="dashboard-card-referral-loader">
      <div :key="key">
        <dashboard-referral-stats v-if="stats" :referrals-stats-resource="stats" @updated="onUpdate"></dashboard-referral-stats>

        <dashboard-referral-list v-if="referrals" :referrals-resource="referrals" :class="stats ? 'mt-10':''" @updated="onUpdate"></dashboard-referral-list>
      </div>
    </div>
  </vx-card>
</template>

<script>
import DashboardReferralStats from '@/views/app/dashboard/referral/dashboard-referral-stats';
import DashboardReferralList from '@/views/app/dashboard/referral/dashboard-referral-list';
import {ResourceImpl} from 'hal-client';

export default {
  name: 'dashboard-referral-card',
  components: {
    DashboardReferralList,
    DashboardReferralStats
  },
  props: {
    dashboardResource: ResourceImpl
  },
  data () {
    return {
      loading: true,
      stats: null,
      referrals: null,
      key: 0
    };
  },
  watch: {
    dashboardResource: {
      immediate: true,
      deep: true,
      handler (newValue) {
        this.doUpdate(newValue);
      }
    },
    loading: {
      handler (value) {
        if (value) {
          if (document.getElementById('dashboard-card-referral-loader')) {
            this.$vs.loading({
              container: '#dashboard-card-referral-loader',
              scale: 0.45
            });
          }
        } else {
          this.$vs.loading.close('#dashboard-card-referral-loader > .con-vs-loading');
        }
      }
    }
  },
  methods: {
    doUpdate (newValue) {
      if (!newValue) return;
      this.loading = true;

      const promises = [];
      if (newValue.$hasLink('referrals-stat')) {
        promises.push(newValue.$request().$get('referrals-stat').then(res => {
          this.stats = res;
          return res;
        }));
      }
      if (newValue.$hasLink('referrals')) {
        promises.push(newValue.$request().$get('referrals').then(res => {
          this.referrals = res;
          return res;
        }));
      }

      Promise.all(promises).then(() => {
        setTimeout(() => {
          this.loading = false;
          this.key++;
        }, 5000);
      }).finally(() => {
        this.key++;
      });
    },
    onUpdate () {
      this.dashboardResource.$request().$getSelf().then(this.doUpdate);
    }
  }
};
</script>

<style scoped>

</style>
